<h3 mat-dialog-title>Wyłączenie przekazania wydatk</h3>

<p>
  Po wyłączeniu przekazania wydatku, odbiorca {{ data.targetEmail }} nie będzie mógł zobaczyć jej szczegółów ani wykonać
  płatności.
</p>

<p>Czy na pewno chcesz wyłączyć przekazanie wydatku?</p>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true">Wyłącz</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
